export type ApiMakeModel = {
  labels: Array<{
    /**
     * Label text
     */
    label: string;
    /**
     * Language code
     */
    language: string;
  }>;
  default_label: string;
  make: string;
  models?: Array<{
    default_label: string;
    labels?: Array<{
      /**
       * Label text
       */
      label: string;
      /**
       * Language code
       */
      language: string;
    }>;
    model: string;
    model_group?: {
      default_label: string;
      group: string;
      labels?: Array<{
        /**
         * Label text
         */
        label: string;
        /**
         * Language code
         */
        language: string;
      }>;
    } | null;
  }>;
};
